// ABOUTME: Smart wrapper for the Order Change Lead Time entity — owns useOrderChangeLeadTimeEntity and reports state via context.
// ABOUTME: Renders skeleton/error/form so the page no longer branches per entity.
import React from 'react'

import {useOrderChangeLeadTimeEntity} from '../hooks/useOrderChangeLeadTimeEntity'
import {useEntityFormContext, useRegisterEntityForm} from '../context/EntityFormContext'
import {EntityContentEmpty} from './EntityContentEmpty'
import {EntityContentError} from './EntityContentError'
import {EntityContentSkeleton} from './EntityContentSkeleton'
import {OrderChangeLeadTimeForm} from './OrderChangeLeadTimeForm'

export const OrderChangeLeadTimeEntityForm: React.FC = () => {
  const ctx = useEntityFormContext()
  const {config, isLoading, error, isSaving, actions} = useOrderChangeLeadTimeEntity({
    countryId: ctx.countryId,
    businessLine: ctx.businessLine,
    scopeId: ctx.selectedScopeId,
    pendingScope: ctx.pendingScope,
    rootScopeId: ctx.rootScopeId,
  })

  useRegisterEntityForm(actions, isSaving)

  if (isLoading) return <EntityContentSkeleton />
  if (error) return <EntityContentError />
  if (!config) return <EntityContentEmpty />

  return (
    <OrderChangeLeadTimeForm
      key={`order-change-lead-time-${ctx.selectedScopeId ?? 'none'}-${ctx.formResetKey}`}
      config={config}
      availableFields={ctx.leadTimeFormOptions?.availableFields}
      isReadOnly={ctx.isReadOnly}
      onDirtyChange={ctx.onDirtyChange}
      onValidChange={ctx.onValidChange}
      onValuesChange={actions.handleValuesChange}
    />
  )
}
